import React from 'react';

export const CancelledIcon = () => {
  return (
    <path
      id="Path_1194" data-name="Path 1194"
      d="M209.774,390.043l-11.5,12.04M213,396a9,9,0,1,1-9-9A9,9,0,0,1,213,396Z" transform="translate(-189 -377)"
      fill="none"
      stroke="#c7372e" strokeLinecap="round"
      strokeLinejoin="round" strokeWidth="2"/>
  );
};
